import { render } from "./Franchises.vue?vue&type=template&id=5af03977"
import script from "./Franchises.vue?vue&type=script&lang=js"
export * from "./Franchises.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__